import Controller from '@ember/controller';
import { tracked } from '@glimmer/tracking';
import { inject as service } from '@ember/service';
import SqlImportModel from 'cio/models/sql-import';
import AlertsService from 'cio/services/alerts';
import ApiErrorsService from 'cio/services/api-errors';
import { task } from 'ember-concurrency';
import { action } from '@ember/object';
import Transition from '@ember/routing/-private/transition';

export default class SqlImportsImportRelationshipsQueryController extends Controller {
  queryParams = [
    {
      runQuery: { as: 'runQuery' },
    },
  ];

  declare model: SqlImportModel;

  @service alerts!: AlertsService;
  @service apiErrors!: ApiErrorsService;

  @tracked runQuery = false;
  @tracked showConfirmExitModal = false;
  @tracked transition: Transition | null = null;

  setDefaults() {
    this.runQuery = false;
  }

  @action
  async resetModel() {
    await this.model.rollbackAttributes();
  }

  @action
  confirmTransition(transition: Transition) {
    this.transition = transition;
    this.showConfirmExitModal = true;
  }

  @action
  discardAndProceed() {
    this.resetModel();
    this.showConfirmExitModal = false;
    this.transition?.retry();
  }

  onSubmitTask = task(async () => {
    try {
      await this.model.updateQuery({
        sql_import: {
          query: this.model.query,
          location: this.model.location,
          relationship: {
            ...this.model.relationship,
            query: this.model.relationship?.query,
          },
        },
      });

      await this.resetModel();
      this.alerts.success('sql-imports.relationships-query', 'Query updated');
    } catch (err) {
      this.apiErrors.report(err);
    }
  });
}

declare module '@ember/controller' {
  interface Registry {
    'sql-imports.import.relationships-query': SqlImportsImportRelationshipsQueryController;
  }
}
